module.exports = __webpack_public_path__ + "img/card-el-4.22e1b29f.svg";